<template>
    <div class="">
        <div class="table_warpper">
            <vxe-table :data="wageTypeData" border stripe :auto-resize="true" ref="dtltable">
                <vxe-table-column title="优先级" type="index" field="index" width="70" align="center"></vxe-table-column>
                <vxe-table-column title="工费来源" field="wagetype_name" width="180"></vxe-table-column>

                <vxe-table-column title="是否启用" field="status" width="180">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status == '1' ? 'success' : scope.row.status == '0' ? 'danger' : ''">{{
                            scope.row.status == 1 ? '显示中' : '未显示'
                        }}</el-tag>
                        <el-switch
                            style="margin-left: 5px"
                            v-model="scope.row.status"
                            active-value="1"
                            inactive-value="0"
                            @change="tableDatastates(scope.row)"
                        >
                        </el-switch>
                    </template>
                </vxe-table-column>

                <vxe-table-column title="应用说明" field="remark"></vxe-table-column>
                <vxe-table-column title="操作" width="180">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleUp(scope.$rowIndex, scope.row)">上移</el-button>
                        <el-button type="text" @click="handleDown(scope.$rowIndex, scope.row)">下移</el-button>
                    </template>
                </vxe-table-column>
            </vxe-table>
            <!-- <div class="save">
                <el-button style="display:block;margin-top:10px" v-preventReClick type="primary" @click="saveIt()">保存</el-button>
            </div> -->
        </div>
    </div>
</template>

<script>
import { wagetypeEmployIndex, wagetypeEmployUpdate, wagetypeLaravelUpdate } from '@/request/api';

export default {
    name: 'vuename',
    data() {
        return {
            wageTypeData: []
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            wagetypeEmployIndex().then(res => {
                this.wageTypeData = res.data;
            });
        },
        saveIt() {
            let dtl = JSON.stringify(this.$refs.dtltable.getTableData().fullData);
            wagetypeLaravelUpdate({ dtl }).then(res => {
                if (res.code == 2000) {
                    this.$message.success(res.data);
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        tableDatastates(row) {
            wagetypeEmployUpdate({
                wagetype_no: row.wagetype_no,
                status: row.status
            }).then(res => {
                if (res.code == 2000) {
                    this.$message.success(res.data);
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 调整顺序，arr 数组，indexAdd 添加元素的位置，indexDvxe 删除元素的位置（indexAdd与indexDvxe交换位置）
        handleChangeOrder(arr, indexAdd, indexDvxe) {
            arr[indexAdd] = arr.splice(indexDvxe, 1, arr[indexAdd])[0];
            return arr;
        },
        // 上移，与前一个元素交换顺序
        handleUp(index, row, type) {
            this.handleChangeOrder(this.wageTypeData, index, index - 1);
            setTimeout(() => {
                this.saveIt();
            }, 500);
        },
        // 下移，与后一个元素交换顺序
        handleDown(index, row, type) {
            this.handleChangeOrder(this.wageTypeData, index, index + 1);
            setTimeout(() => {
                this.saveIt();
            }, 500);
        }
    }
};
</script>

<style scoped lang="scss">
.table_warpper {
    padding: 15px;
    box-sizing: border-box;
    background-color: #fff;
}
.save {
    width: 100%;
    border-top: 1px solid #e7e7e7;
    margin-top: 48px;
}
</style>
